module.exports = __webpack_public_path__ + "static/media/pic2.6373ac6b.jpg";